import React from 'react'

import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import styles from './ReturnLink.module.scss'
import returnLinkImage from '@/assets/images/home-link.svg'
import { Icon } from '@/Atomic/Atoms/Icon'
import { Tooltip } from '@/Atomic/Molecules/Tooltip'

export type ReturnLinkTarget = 'home' | 'automations'

export interface ReturnLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string
  targetType: ReturnLinkTarget
  className?: string
}

export const ReturnLink = React.forwardRef<HTMLAnchorElement, ReturnLinkProps>(
  ({ href, targetType, className, ...anchorAttributes }, linkRef) => {
    const { t } = useTranslation()

    if (targetType === 'automations') {
      return (
        <div className={classNames(styles.automationBanner, className)}>
          <Icon icon="alert-circle" color="white" size="md" />
          <span className={styles.automationText}>
            {t('components.returnLink.automationBannerText')}
          </span>
          <a
            ref={linkRef}
            href={href}
            className={styles.automationLink}
            {...anchorAttributes}
          >
            {t('components.returnLink.backToAutomations')}
          </a>
        </div>
      )
    }

    const compactLink = (
      <a
        ref={linkRef}
        href={href}
        className={classNames(styles.brandLink, className)}
        data-tooltip-id={
          targetType === 'home' ? 'return-home-link-tooltip' : undefined
        }
        {...anchorAttributes}
      >
        <img
          src={returnLinkImage}
          alt=""
          aria-hidden="true"
          className={styles.image}
        />
        <span className={styles.homeText}>
          {t('components.returnLink.backToHome')}
        </span>
      </a>
    )

    if (targetType !== 'home') return compactLink

    return (
      <>
        {compactLink}
        <Tooltip
          id="return-home-link-tooltip"
          content={t('components.returnLink.backToHome')}
        />
      </>
    )
  },
)

ReturnLink.displayName = 'ReturnLink'

export default ReturnLink
